let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("laMcO")).then(() => parcelRequire('hwMbC'));